document.querySelectorAll('[data-facet-group-toggle]').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const group = toggle.closest('[data-facet-group]');
    group.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', group.classList.contains('is-open') ? 'true' : 'false');
  });
});

document.querySelectorAll('[data-facet-group]').forEach((group) => {
  const hasActive = group.querySelector('.facets__checkbox:checked');
  if (hasActive) {
    group.classList.add('is-open');
    const toggle = group.querySelector('[data-facet-group-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
});
